import React, { useEffect } from 'react';
import './SignIn.css';

const SignIn = () => {
  const handleSignIn = () => {
    window.location.href = 'https://accounts.aurumi.ai';
  };

  useEffect(() => {
    // Complete back button disable
    const disableBackButton = () => {
      // Clear any existing history
      window.history.replaceState(null, null, window.location.pathname);
      // Push multiple states to make back button ineffective
      for (let i = 0; i < 10; i++) {
        window.history.pushState(null, null, window.location.pathname);
      }
    };

    // Initial disable
    disableBackButton();

    // Handle all navigation attempts
    const handlePopState = (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      // Show alert when back button is clicked
      
      
      // Force stay on current page
      window.history.pushState(null, null, window.location.pathname);
      return false;
    };

    // Handle browser navigation (including back button, keyboard shortcuts)
    const handleBeforeUnload = (event) => {
      // This won't prevent back button but helps with other navigation
      event.preventDefault();
      return '';
    };

    // Block keyboard shortcuts like Alt+Left, Backspace navigation
    const handleKeyDown = (event) => {
      // Block Backspace navigation (when not in input field)
      if (event.keyCode === 8 && !['INPUT', 'TEXTAREA'].includes(event.target.tagName)) {
        event.preventDefault();
        alert('Back navigation is disabled on this page.');
        return false;
      }
      // Block Alt + Left Arrow (back)
  
      // Block Alt + Right Arrow (forward)
   
    };

    // Add all event listeners
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keydown', handleKeyDown);

    // Override browser's back functionality
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', function() {
        alert('Back navigation is disabled on this page.');
        window.history.pushState(null, null, window.location.pathname);
      });
    }

    // Cleanup all event listeners on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="container">
      <div className="card">
        <div>
          <img
            src="/AurumiLogo.png"
            alt="Aurumi Logo"
            className="logo-img"
          />
        </div>
        <h2 className="heading">Sign in to Aurumi</h2>
        <p className="description">
          Access your account securely with your Aurumi credentials.
        </p>
        <button onClick={handleSignIn} className="btn-primary">
          Sign in with Aurumi Account
        </button>
      </div>
    </div>
  );
};

export default SignIn;
